import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdministradoraListarComponent } from './administradora-listar.component';



@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: AdministradoraListarComponent }    
    ])],
    exports: [RouterModule]
})
export class AdministradoraListarRoutingModule { }
